export default {
  projectDesc: '基于 <strong>Vue2</strong> 的简洁、易用的中国行政区划选择器<br>包含常规表单下拉列表模式、UI下拉选择器模式和纯文本展示等模式<br>支持 “省/直辖市” - “市” - “区/县” - “乡/镇/街道”4级行政级别',
  demo: {
    modes: {
      formElement: '常规表单下拉元素模式',
      plainText: '纯文本模式',
      selector: '选择器模式'
    },
    desc: '包含常规表单模式与下拉选择器模式',
    province: '省/直辖市',
    city: '市',
    area: '区/县',
    town: '乡/镇/街道',
    selected: '行政区划选择结果',
    init: '初始化行政区划选中项目',
    dropdown: '多分组切换模式',
    customCaller: '自定义选择器呼出对象',
    disabled: '禁用选择组件',
    text: '初始化的区域信息以纯文本形式展示',
    textSeparator: '区域间应用分隔符显示文本内容',
    columns: {
      title: '多列竖排模式选择器',
      base: '多列竖排核心模块'
    },
    group: {
      title: '多分组模式选择器',
      base: '多分组模式核心模块'
    },
    cityPicker: '城市选择器'
  },
  option: {
    blank: '是否生成 “请选择” 的默认项目，仅在 “RegionSelcts” 模式有效',
    city: '允许 城市 级别',
    area: '允许 区/县 级别',
    town: '允许 乡/镇/街道 级别',
    search: '允许开启下拉选择器的搜索栏，仅在 “RegionGroup” 模式有效',
    selected: '初始化行政区划选中项目',
    cityPickerSelected: '城市选择器初始化选中项目数据格式：',
    disabled: '禁用行政区划选择元素，仅在 “RegionSelcts” 模式有效',
    language: '插件使用语言',
    separator: '区域文本间的分隔符，仅在 “RegionText” 模式有效',
    overflow: '选中的城市较多时，其他的城市仅以数量显示，仅在 “RegionCityPicker” 模式有效'
  },
  event: {
    values: '响应已选中的行政区划完整数据模型'
  }
}
